import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faTimes,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

import Util, { HistState } from 'service/util';

import moment from 'moment';
import Protected from 'component/Protected';

const today = Util.getToday();

class ServiceList extends React.Component
{
  render()
  {
    return (
      <div className="service-history">
        <div className="thead grid-row">
          <div className="srv-buttons"></div>
          <div className="srv-company"   >公司</div>
          <div className="srv-reg-dtm"   >開戶日期</div>
          <div className="srv-start-dtm" >開始日期</div>
          <div className="srv-end-dtm"   >結束日期</div>
          <div className="srv-plan"      >計劃</div>
          <div className="srv-rot"       >附加項目</div>
          <div className="srv-fee"       >月費</div>
          <div className="srv-exfee"     >附加費</div>
          <div className="srv-weekday"   >服務日</div>
          <div className="srv-location"  >地點</div>
          <div className="srv-floor"     >樓層</div>
          <div className="srv-psn"       >車位</div>
          <div className="srv-waxing"    >打蠟</div>
          <div className="srv-worker"    >工人</div>
          <div className="srv-create-dtm">更改日期</div>
          <div className="srv-create-by" >修訂人</div>
        </div>
        { this.props.services.map((x,i) =>
          <ServiceRow key={`srv-${x.company}-${i}`}
            service={x}
            showModal={this.props.showModal}
            prevItem={this.props.services[i+1]}
            gm_end_dtm={this.props.gm_end_dtm} />
        )}
      </div>
    );
  }
}

class ServiceRow extends React.Component
{

  getRecordStatus(row)
  {
    let st = moment(row.start_dtm);
    let et = row.end_dtm && moment(row.end_dtm);
    if (st.isAfter(today)) return HistState.Future;
    if (!et || et.isSameOrAfter(today)) return HistState.Present;
    return HistState.Past;
  }

  createUpdateButton(row, gm_end_dtm) /* global max */
  {
    let min_date;
    switch ( this.getRecordStatus(row) )
    {
      case HistState.Future:
        min_date = !gm_end_dtm ? null : new Date(moment(gm_end_dtm).add(1, 'd').valueOf());
        return <FontAwesomeIcon icon={faPen} className="btn-modify" onClick={ e=> this.props.showModal('edit', min_date, row)}/>;
      case HistState.Present:
        min_date = this.props.prevItem?.end_dtm && new Date(this.props.prevItem.end_dtm).setHours(24,0,0,0);
        return <FontAwesomeIcon icon={faPen} className="btn-modify" onClick={ e=> this.props.showModal('change', min_date, row)}/>;
    }
    return '';
  }
  createRemoveButton(row)
  {
    switch ( this.getRecordStatus(row) )
    {
      case HistState.Future:
        return <FontAwesomeIcon icon={faTimes} className="btn-remove" onClick={ e=> this.props.showModal('del', null, row)}/>;
      case HistState.Present:
        if (row.end_dtm) return ''; // cannot "terminate" a terminated/suspended service
        let min_date = new Date(row.start_dtm).setHours(24,0,0,0);
        return <FontAwesomeIcon icon={faTimes} className="btn-remove" onClick={ e=> this.props.showModal('term', min_date, row)}/>;
    }
    return '';
  }

  render()
  {
    const x = this.props.service;
    let _rowStyle = (x) => {
      let cls = ['service-record', 'grid-row'];
      switch (this.getRecordStatus(x))
      {
        case HistState.Present: cls.push('active'); break;
        case HistState.Future:  cls.push('future'); break;
      }

      let prv = this.props.prevItem;
      if (prv?.end_dtm && moment(x.start_dtm).diff(prv.end_dtm , 'day') > 1) {
        cls.push('service-gap');
      }

      return cls.join(' ');
    };

    return (
      <div className={_rowStyle(x)}>
        <div className="srv-buttons">
          <Protected allow={['ADMIN','OPERATOR']}>
            <div className="btn-box">{ this.createRemoveButton(x, this.props.gm_end_dtm) }</div>
            <div className="btn-box">{ this.createUpdateButton(x, this.props.gm_end_dtm) }</div>
          </Protected>
        </div>
        <div className="srv-company">{ Util.getCompanyName(x.company) }</div>
        <div className="srv-reg-dtm">{ Util.ShortDate(x.reg_dtm) }</div>
        <div className="srv-start-dtm">{ Util.ShortDate(x.start_dtm) }</div>
        <div className="srv-end-dtm">{ Util.ShortDate(x.end_dtm) }</div>
        <div className="srv-plan">
          <span className={`p ${x.srv_plan}`}>{ x.srv_plan }{ x.vh_type }</span>
        </div>
        <div className="srv-rot">{ x.rotation }</div>
        <div className="srv-fee">${ x.fee }</div>
        <div className="srv-exfee">${ x.extra_fee }</div>
        <div className="srv-weekday">
          <span>{ Util.WeekdayName(x.weekday1) }</span>
          <span>{ Util.WeekdayName(x.weekday2) }</span>
          <span>{ Util.WeekdayName(x.weekday3) }</span>
        </div>
        <div className="srv-location">{x.srv_dis}{x.srv_loc}</div>
        <div className="srv-floor">{x.srv_floor}</div>
        <div className="srv-psn">{x.srv_psn}</div>
        <div className="srv-waxing">
          { !x.waxing?'':<FontAwesomeIcon icon={faCheck} /> }
        </div>
        <div className="srv-worker" tilte={ `ID:${x.worker}` }>
          { x.worker_name }
        </div>
        <div className="srv-create-date">
          { Util.FullDate(x.create_dtm) }
        </div>
        <div className="srv-create-by">
          { x.create_by }
        </div>
      </div>
    );
  }
}

export default ServiceList;